import {
    Input, Radio, RadioChangeEvent, Space, Tabs,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import React, { ChangeEvent } from "react";
import { getTranslate, TranslateFunction } from "react-localize-redux";
import { connect } from "react-redux";
import { ProjectType } from "../../enums/enums";
import { JobEntity, PhaseConfigNormalized } from "../../interfaces/store/actions/payload/job";
import StoreState from "../../interfaces/store/storeState";
import {
    claimJobPhase,
    completeJobPhase,
    getJobPhaseWorkflowDefinitions,
    openCtWebJob,
    openExternalJob,
    setActiveJobType,
    setFilterType,
    setSelectedJob,
    showConfirmClaimDialog,
    showDetailsDrawer,
    toggleInitiateWorkDialog,
} from "../../store/actions/job";
import Announcement from "../Announcement/Announcement";
import { CardItem } from "../CardItem/CardItem";
import MarkdownMedia from "../MarkdownMedia/MarkdownMedia";
import { TaskDetails } from "../TaskDetails/TaskDetails";
import "./MarkdownPreview.scss";

interface Props {
    translate: TranslateFunction
}

interface State {
    jobDescription: string
    jobDirections: string
    projectType: string
    announcementHeadline: string
    announcementPicture: string
    announcementIntroduction: string
    announcementContent: string
}

class MarkdownPreview extends React.Component<Props, State> {
    state = {
        jobDescription: "",
        jobDirections: "",
        projectType: ProjectType.OTHER,
        announcementHeadline: "",
        announcementPicture: "",
        announcementIntroduction: "",
        announcementContent: "",
    };

    constructor(props: Props) {
        super(props);

        this.updateJobDescription = this.updateJobDescription.bind(this);
        this.updateJobDirections = this.updateJobDirections.bind(this);
        this.updateProjectType = this.updateProjectType.bind(this);
        this.updateAnnouncementHeadline = this.updateAnnouncementHeadline.bind(this);
        this.updateAnnouncementPicture = this.updateAnnouncementPicture.bind(this);
        this.updateAnnouncementIntroduction = this.updateAnnouncementIntroduction.bind(this);
        this.updateAnnouncementContent = this.updateAnnouncementContent.bind(this);
    }

    updateJobDescription({target: {value}}: ChangeEvent<HTMLTextAreaElement>) {
        this.setState({jobDescription: value});
    }

    updateJobDirections({target: {value}}: ChangeEvent<HTMLTextAreaElement>) {
        this.setState({jobDirections: value});
    }

    updateProjectType({target: {value}}: RadioChangeEvent) {
        this.setState({projectType: value});
    }

    updateAnnouncementHeadline({target: {value}}: ChangeEvent<HTMLInputElement>) {
        this.setState({announcementHeadline: value});
    }

    updateAnnouncementPicture({target: {value}}: ChangeEvent<HTMLInputElement>) {
        this.setState({announcementPicture: value});
    }

    updateAnnouncementIntroduction({target: {value}}: ChangeEvent<HTMLTextAreaElement>) {
        this.setState({announcementIntroduction: value});
    }

    updateAnnouncementContent({target: {value}}: ChangeEvent<HTMLTextAreaElement>) {
        this.setState({announcementContent: value});
    }

    render() {
        const {
            jobDescription,
            jobDirections,
            projectType,
            announcementHeadline,
            announcementPicture,
            announcementIntroduction,
            announcementContent,
        }: State = this.state;
        const {translate}: Props = this.props;

        const jobMock: JobEntity = {
            assignee: "",
            stopped: true,
            open: true,
            started: true,
            name: "Annotation",
            projectType: "ANNOTATION",
            title: "Transcription Training (English)",
            description: jobDescription,

            assignmentType: "MOCK",
            id: "MOCK",
            jobId: "MOCK",
            projectId: "MOCK",
            status: "MOCK",
            workflowDefinitionId: "MOCK",
            idx: 1,
            taskCount: 1,
            version: 1,
            tags: [],
            phaseStats: {},
            taskStats: {
                NEW: 1,
                IN_PROGRESS: 1,
                COMPLETED: 1,
                REJECTED: 1,
            },
            // cloneCount?: number
            // cloneLimit?: number
            // dueDate?: number
            // projectManager?: string
            // userCloneLimit?: number
            // rejectedTaskCount?: number
            // userCloneCount?: number
            // completedTaskCount?: number
            // estimatedTime? : number
            // featured?: boolean
        };

        const phaseConfigList: PhaseConfigNormalized = {
            "ANNOTATION-Annotation": {
                auto: false,
                claimEnabled: false,
                editor: "annotation",
                enableBulkCompletePhaseAction: false,
                id: "MOCK",
                name: "Annotation",
                projectType: "ANNOTATION",
                version: 1,
                review: false,
            },
        };

        return (
            <Tabs className="df-markdown-preview">
                <Tabs.TabPane
                    tab="Job (card and details side panel)"
                    key="job"
                    className="df-markdown-preview-job"
                >
                    <div className="df-inputs-and-job-preview">
                        <TextArea
                            value={jobDescription}
                            placeholder="Input job description markdown here"
                            onChange={this.updateJobDescription}
                        />
                        <TextArea
                            value={jobDirections}
                            placeholder="Input job directions markdown here"
                            onChange={this.updateJobDirections}
                        />
                        <div className="df-media-storage-container">
                            <div className="df-media-storage-label">
                                Media Storage Location:
                            </div>
                            <Radio.Group
                                value={projectType}
                                onChange={this.updateProjectType}
                            >
                                <Space>
                                    <Radio
                                        key={ProjectType.ANNOTATION}
                                        value={ProjectType.ANNOTATION}
                                    >
                                        Annotation
                                    </Radio>
                                    <Radio
                                        key={ProjectType.TRANSCRIPTION}
                                        value={ProjectType.TRANSCRIPTION}
                                    >
                                        Transcription
                                    </Radio>
                                    <Radio
                                        key={ProjectType.OTHER}
                                        value={ProjectType.OTHER}
                                    >
                                        Other
                                    </Radio>
                                </Space>
                            </Radio.Group>
                        </div>
                        <div className="df-job-item-preview">
                            <CardItem
                                editors={{}}
                                phaseConfigList={phaseConfigList}
                                workflowDefinitionList={[]}
                                translate={translate}
                                isMobile={false}
                                activeJobType="a"
                                activeTestType="b"
                                claimJobPhase={claimJobPhase}
                                completeJobPhase={completeJobPhase}
                                showConfirmClaimDialog={showConfirmClaimDialog}
                                getJobPhaseWorkflowDefinitions={getJobPhaseWorkflowDefinitions}
                                toggleInitiateWorkDialog={toggleInitiateWorkDialog}
                                showDetailsDrawer={showDetailsDrawer}
                                setSelectedJob={setSelectedJob}
                                openExternalJob={openExternalJob}
                                setActiveJobType={setActiveJobType}
                                setFilterType={setFilterType}
                                data={jobMock}
                                hideBtnDropdown
                                appStoreUrl="mockUrl"
                                playStoreUrl="mockUrl"
                                isTest={false}
                                openCtWebJob={openCtWebJob}
                            />
                        </div>
                    </div>
                    <div className="df-task-drawer-preview">
                        <Tabs type="card">
                            <Tabs.TabPane
                                tab="Summary"
                                key="summary-preview"
                            >
                                <TaskDetails
                                    data={jobMock}
                                    activeJobType=""
                                    translate={translate}
                                    isTest={false}
                                />
                            </Tabs.TabPane>
                            <Tabs.TabPane
                                tab="Directions"
                                key="markdown-preview"
                            >
                                <MarkdownMedia
                                    projectType={projectType}
                                    tocElements={["h1"]}
                                >
                                    {jobDirections}
                                </MarkdownMedia>
                            </Tabs.TabPane>
                        </Tabs>
                    </div>
                </Tabs.TabPane>
                <Tabs.TabPane
                    tab="Announcement"
                    key="announcement"
                    className="df-markdown-preview-announcement"
                >
                    <Input
                        value={announcementHeadline}
                        placeholder="Input Headline text here"
                        onChange={this.updateAnnouncementHeadline}
                    />
                    <Input
                        value={announcementPicture}
                        placeholder="Input Image url here (optional)"
                        onChange={this.updateAnnouncementPicture}
                    />
                    <TextArea
                        value={announcementIntroduction}
                        placeholder="Input Introduction (brief text) markdown here"
                        onChange={this.updateAnnouncementIntroduction}
                    />
                    <TextArea
                        value={announcementContent}
                        placeholder="Input Content (full text) markdown here"
                        onChange={this.updateAnnouncementContent}
                    />
                    <div className="df-task-announcement-wrapper">
                        <Announcement data={{
                            Headline: announcementHeadline,
                            Picture: announcementPicture,
                            Introduction: announcementIntroduction,
                            Content: announcementContent,
                            Date: dayjs()
                                .format("d-MMM-YY"),
                        }}
                        />
                    </div>
                </Tabs.TabPane>
            </Tabs>
        );
    }
}

function mapStateToProps(state: StoreState): Props {
    return {
        translate: getTranslate(state.localize),
    };
}

export default connect(mapStateToProps)(MarkdownPreview);
